export const handsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 25.882 25.681"
  >
    <g
      id="Group_2"
      data-name="Group 2"
      transform="translate(-1254.775 148.026)"
    >
      <line
        id="Line_1"
        data-name="Line 1"
        x1="3.891"
        y1="3.944"
        transform="translate(1275.995 -133.768)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.089"
      />
      <path
        id="Path_4"
        data-name="Path 4"
        d="M12.879,19.642c.148.134.292.275.432.42L17.9,24.886"
        transform="translate(1255 -148)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.089"
      />
      <path
        id="Path_5"
        data-name="Path 5"
        d="M4.737,14.05a5.761,5.761,0,0,1-.7.909l-3.5,3.217"
        transform="translate(1255 -148)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.089"
      />
      <path
        id="Path_6"
        data-name="Path 6"
        d="M19.214,16.063q.084-.081.165-.165l4.479-4.638a1.6,1.6,0,1,0-2.309-2.229l.115-.114-.115.114.844-.874a1.6,1.6,0,1,0-2.308-2.228l-.591.619L20.625,5.37a1.6,1.6,0,0,0-2.308-2.229L17.309,4.185l.438-.453A1.6,1.6,0,0,0,15.439,1.5"
        transform="translate(1255 -148)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.089"
      />
      <path
        id="Path_7"
        data-name="Path 7"
        d="M7.892,24.886l4.542-4.825a8.512,8.512,0,0,1,3.819-2.293,6.99,6.99,0,0,0,1.611-.684"
        transform="translate(1255 -148)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.089"
      />
      <path
        id="Path_8"
        data-name="Path 8"
        d="M5.346,6.294A1.6,1.6,0,1,0,3.038,8.523L5.7,11.283A1.6,1.6,0,0,0,8.012,9.054"
        transform="translate(1255 -148)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.089"
      />
      <path
        id="Path_9"
        data-name="Path 9"
        d="M8.413,4.851l-1.3-1.345A1.6,1.6,0,0,0,4.807,5.735L8.043,9.086a1.6,1.6,0,0,0,2.308-2.229L9.6,6.077"
        transform="translate(1255 -148)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.089"
      />
      <path
        id="Path_10"
        data-name="Path 10"
        d="M10.35,6.857a1.6,1.6,0,1,0,2.308-2.229l-.178-.183"
        transform="translate(1255 -148)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.089"
      />
      <path
        id="Path_11"
        data-name="Path 11"
        d="M10.7,2.6l-.706-.731A1.6,1.6,0,1,0,7.685,4.1"
        transform="translate(1255 -148)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.089"
      />
      <path
        id="Path_12"
        data-name="Path 12"
        d="M3.882,9.4a1.6,1.6,0,0,0-2.309,2.228l1.852,1.919a1.6,1.6,0,0,0,2.309-2.229"
        transform="translate(1255 -148)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.089"
      />
      <path
        id="Path_13"
        data-name="Path 13"
        d="M15.439,1.5,13.609.64a.993.993,0,0,0-1.122.192L10.132,3.165a.646.646,0,0,0-.01.907,1.977,1.977,0,0,0,2.847,0Z"
        transform="translate(1255 -148)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.089"
      />
    </g>
  </svg>
);
